import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idCliente: number | null, openState: boolean) => void,
    onActionDelete: (idCliente: number | null, openState: boolean) => void,

}

export const GenerateClientesListaColumns = ({
    onActionEdit,
    onActionDelete,

}: Props): GridColDef[] => {


    return [

        {
            field: "codigo",
            filterable: false,
            headerName: "N°",
            flex: 1,
            minWidth: 100,
            maxWidth: 100,
            sortable: false,
        },
        {
            field: "nomeFantasia",
            filterable: false,
            headerName: "Nome do Cliente",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "unidadeCentroCustoPrincipal",
            filterable: false,
            headerName: "Unidade Centro Custo Principal",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: " Centro de Custo",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "dataCadastro",
            filterable: false,
            headerName: "Data de Cadastro",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },

        {
            field: 'idCliente',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}